<mp-custom-chip class="sign-status" [chip]="{ label: signStatusLabel() }" [small]="small()" />
